<template>
  <McTable
    :fields="vendorContractListFields"
    :apiClient="vendorContractApiClient"
    :customHandlers="customHandlers"
    :hasCheckbox="false"
    class="mc-table"
  >
    <template #cell(status.name)="{ value, item }">
      <span
        v-if="item.status?.color"
        class="__status-dots"
        :style="{ backgroundColor: item.status.color }"
      ></span>
      <span style="color: #344264; font-weight: bold">{{ value }}</span>
    </template>

    <template #cell(version.addendum)="{ value }">
      <div>v.{{ value }}</div>
    </template>

    <template #cell(effective_date)="{ value }">
      <div>{{ formatIndexDate(value, 'DD MMMM YYYY').date }}</div>
    </template>

    <template #cell(expired_date)="{ value }">
      <div>{{ formatIndexDate(value, 'DD MMMM YYYY').date }}</div>
    </template>
  </McTable>
</template>

<script>
import McTable from '@/components/McTable'
import { formatIndexDate } from '@/helpers/tzDate'

import vendorContractListFields from '../lib/fields/vendor-contract-list-fields'
import * as VendorContract from '@/services/rest-api/lib/vendor/contract'

export default {
  components: {
    McTable,
  },
  props: {
    vendorId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      customHandlers: {
        handleClickRow: this.handleClickRow,
      },
    }
  },
  computed: {
    vendorContractListFields() {
      return vendorContractListFields
    },
    vendorContractApiClient() {
      return {
        get: VendorContract.getByVendorId(this.vendorId),
      }
    },
  },
  methods: {
    formatIndexDate,
    handleClickRow(item) {
      this.$router.push({
        name: 'Master Vendor Contract Detail',
        params: {
          vendorId: item.vendor.id,
          contractId: item.id,
          versionId: item.version.id,
        },
        query: { vendorId: this.vendorId },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.mc-table {
  .__status-dots {
    display: inline-block;
    margin: auto;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 8px;
  }
}
</style>
